// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"d28f63e7e837ec29c866","655":"30eb442262799967548d"}[chunkId] + ".js";
};